import PropTypes from 'prop-types';
import React from 'react';

import Position from '../../marvel-ui-position';
import Spacing from '../../marvel-ui-spacing';
import { InlineGrid } from '../../marvel-ui-grid';

export default function CardActions({ children }) {
  return (
    <Position location="topRight">
      <Spacing size="xs" type="padding">
        <InlineGrid size="xxs">{children}</InlineGrid>
      </Spacing>
    </Position>
  );
}

CardActions.propTypes = {
  children: PropTypes.node.isRequired,
};



// WEBPACK FOOTER //
// ./packages/marvel-ui-card/CardActions/index.js